import { render, staticRenderFns } from "./account-profile.vue?vue&type=template&id=545b0cc5&scoped=true&"
import script from "./account-profile.vue?vue&type=script&lang=js&"
export * from "./account-profile.vue?vue&type=script&lang=js&"
import style0 from "./account-profile.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./account-profile.vue?vue&type=style&index=1&id=545b0cc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b0cc5",
  null
  
)

export default component.exports